import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNavigation.css';
import ApiService from '../services/api';

function BottomNavigation({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchNotificationCount = async () => {
    try {
      const data = await ApiService.getNotifications();
      const unread = data.filter ? data.filter(n => !n.read).length : 0;
      setNotificationCount(unread);
    } catch {
      // Silently fail
    }
  };

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/tasks', icon: '📋', label: 'Tasks' },
    { path: '/calendar', icon: '📅', label: 'Calendar' },
    { path: '/tracking', icon: '📍', label: 'Tracking' },
    { path: '/profile', icon: '👤', label: 'Profile' },
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <button
          key={item.path}
          className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <span className="nav-icon">
            {item.path === '/profile' ? (
              <span className="notification-badge">
                {item.icon}
                {notificationCount > 0 && (
                  <span className="badge">{notificationCount > 99 ? '99+' : notificationCount}</span>
                )}
              </span>
            ) : (
              item.icon
            )}
          </span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNavigation;